
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contractors/submission-success",
      function () {
        return require("private-next-pages/contractors/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contractors/submission-success"])
      });
    }
  